/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { request } from "../../../utils/request";
import { useParams } from "react-router-dom";
import Form from "./Components/FacturaForm";
import InvalidScreen from "../../general/InvalidScreen";
import { isVendedor, toast } from "../../../utils/helpers";
import useLocalStorage from "../../../hooks/useLocalStorage";

const isRecovery = !!(localStorage.getItem('facturaGuardada'));

// Al duplicar solo se copia lo que describe la venta. Todo lo que identifica a
// la factura original (id, NCF, fecha, pagos, documento DGII, factura firmada,
// recurrencia) se descarta: si llegara al formulario se enviaría como inputs
// ocultos o adjuntos de la factura nueva. Sin `total` tampoco se toma la
// original como monto previo al calcular el crédito disponible.
const datosParaDuplicar = (factura) => ({
	cliente: factura.cliente,
	vendedor: factura.vendedor,
	ruta: factura.ruta,
	plazo: factura.plazo,
	productos: factura.productos,
	notas: factura.notas,
	categorias: factura.categorias,
	direccion_entrega: factura.direccion_entrega,
	// La fecha pasa a ser hoy (ver setEditInfo), así que el vencimiento de la
	// original quedaría atrasado: se recalcula con los días del plazo.
	fecha_vencimiento: dayjs().add(factura.plazo?.dias ?? 0, "day").format("YYYY-MM-DD"),
});

// Un pedido o cotización solo se factura estando pendiente. El backend lo
// impone (CreateFactura::bloquearOrigen) y responde con este mismo texto; aquí
// se avisa al abrir, para no dejar llenar un formulario que no se va a guardar.
export const motivoNoFacturable = (origen, esPedido) => {
	// Sin estado no se presume nada: el backend decide al guardar.
	if (!origen?.estado || origen.estado === "pendiente") return null;

	const sujeto = esPedido ? "El pedido" : "La cotización";
	const o = esPedido ? "o" : "a";
	const documento = [origen.numero_comprobante, origen.cliente?.nombre]
		.filter(Boolean)
		.join(" ");
	const motivo =
		origen.estado === "facturada"
			? `ya está facturad${o}`
			: origen.estado === "cancelada"
			? `está cancelad${o} y no se puede facturar`
			: `está en estado "${origen.estado}" y no se puede facturar`;

	return `${sujeto} ${documento} ${motivo}.`;
};

const CrearFactura = ({ duplicar = false }) => {
	const [fromOrden] = useLocalStorage("fromOrden");
	const [facturaGuardada, setFacturaGuardada] = useLocalStorage('facturaGuardada');
    const { plantilla } = useParams();

	const [factura, setFactura] = useState({});
	const [noFacturable, setNoFacturable] = useState(null);

	const getPlantilla = (id, fromOrden) => {
		if (duplicar) {
			request("facturas/" + id).then((res) => {
				setFactura(datosParaDuplicar(res.data));
			});
			return;
		}

		request((fromOrden ? "ordenes-compra/" : "cotizaciones/") + id).then((res) => {
			const motivo = motivoNoFacturable(res.data, fromOrden);
			if (motivo) {
				setNoFacturable(motivo);
				return;
			}
			setFactura(res.data);
		});
	};

	useEffect(() => {
        if (plantilla) {
            getPlantilla(plantilla, fromOrden === "si");
        }

        const isToday = facturaGuardada?.fecha && new Date(facturaGuardada.fecha + 'T00:00:00').toDateString() === new Date().toDateString();
        if (isRecovery && !plantilla && facturaGuardada && isToday) {
            setFactura(facturaGuardada);
            toast('Reestableciendo Autoguardado...');
        }
	}, []);

	if (noFacturable) {
		return <InvalidScreen message={noFacturable} />;
	}

	/*if (isVendedor() && !localStorage.getItem("rutas")) {
		return <InvalidScreen message="No hay zonas seleccionadas" />;
	}*/

	return (
		<>
			<Form
				facturaActual={factura}
				isEdit={false}
				isRecovery={isRecovery}
				fromPlantilla={plantilla ? true : false}
				esDuplicado={duplicar}
                setFacturaGuardada={setFacturaGuardada}
			/>
		</>
	);
};

export default CrearFactura;
